import {
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAIL,
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  CLEAR_ACTION_RESULT
} from "./actionTypes"

export const editProfile = astroUser => {
  return {
    type: EDIT_PROFILE,
    payload: { astroUser },
  }
}

export const editProfileSuccess = msg => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: msg,
  }
}

export const editProfileError = error => {
  return {
    type: EDIT_PROFILE_FAIL,
    payload: error,
  }
}

export const getProfile = () => ({
  type: GET_PROFILE,
})

export const getProfileSuccess = astroUser => ({
  type: GET_PROFILE_SUCCESS,
  payload: astroUser,
})

export const getProfileFail = error => ({
  type: GET_PROFILE_FAIL,
  payload: error,
})

export const clearActionResult = () => ({
  type: CLEAR_ACTION_RESULT,
})